import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API, axios } from "@/api";
import { BottomNav } from "@/components/shared/Navigation";
import SmartOfferCard from "@/components/cards/SmartOfferCard";
import { ArrowLeft, Loader2, MapPin } from "lucide-react";

export default function CityDealsPage() {
  const { cityName } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!cityName) return;
    axios.get(`${API}/offers/by-city/${encodeURIComponent(cityName)}`)
      .then(r => setData(r.data))
      .catch(() => setData({ city: cityName, count: 0, offers: [] }))
      .finally(() => setLoading(false));
  }, [cityName]);

  return (
    <div className="min-h-screen pb-24" style={{ backgroundColor: "var(--theme-page-bg, #ffffff)" }} data-testid="city-deals-page">
      {/* Header */}
      <div className="bg-white border-b border-slate-100 px-4 pt-5 pb-4 sticky top-0 z-50">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate("/whats-new")} className="p-1.5 rounded-xl bg-slate-100 hover:bg-slate-200 transition" data-testid="city-deals-back">
            <ArrowLeft className="w-4 h-4 text-slate-600" />
          </button>
          <div className="flex-1">
            <h1 className="text-lg font-bold text-slate-800">{cityName}</h1>
            <div className="flex items-center gap-1 mt-0.5">
              <MapPin className="w-3 h-3 text-slate-400" />
              <p className="text-[11px] text-slate-400">
                {data ? `${data.count} confirmed birthday deal${data.count !== 1 ? 's' : ''}` : 'Loading...'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-4 pt-4">
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <Loader2 className="w-6 h-6 animate-spin text-slate-300" />
          </div>
        ) : !data || data.count === 0 ? (
          <div className="text-center py-16" data-testid="city-deals-empty">
            <p className="text-slate-700 font-semibold">No confirmed deals yet</p>
            <p className="text-slate-400 text-sm mt-1">We're still researching businesses in {cityName}.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {data.offers.map((offer) => (
              <SmartOfferCard
                key={offer.business_id}
                offer={offer}
                onClick={() => navigate(`/offer/${offer.business_id}`)}
              />
            ))}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}
